<template>
  <div class="article ">
    <div class="bg-white">
      <div class="middle-main">

        <!-- <div class="banner-swiper justify-center bg-white">
          <div class="swiper-box">
            <swiper :options="swiperOption1" ref="mySwiper">
              <swiper-slide v-for="item in newsSwiperRes" :key="item">
                <div
                  class="news-item flex-row hand"
                  @click="toDetails(item)"
                >
                  <img :src="item.newsImage" class="news-img hand" />
                  <div class="news-info flex-col justify-center">
                    <h3 class="font40 text-black">
                      {{ item.newsTitle }}
                    </h3>
                    <p class="font14 text-black">
                    </p>
                    <div class="more font20 text-white bg-red items-center">
                      READ MORE
                      <svg-icon icon-class="Group 16"></svg-icon>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination1" slot="pagination"></div>
            <div class="swiper-button-prev1 items-center justify-center hand" v-if="isPc==1">
            <svg-icon icon-class="arrow"></svg-icon>
          </div>
          <div class="swiper-button-next1 items-center justify-center hand" v-if="isPc==1">
            <svg-icon icon-class="arrow"></svg-icon>
          </div>
          </div>
        </div> -->

        <el-row :gutter="isPc!=3?'30':0">
          <el-col :span="isPc!=3?16:24">
            <h1 class="title">{{typeArr.find(item => item.typeId == typeId).title}}</h1>
            <news-list :typeId="typeId" img-direction="flex-row" />
          </el-col>
          <el-col :span="8" v-if="isPc!=3">
            <div class="like-news">
              <h3>
                {{ typeId == 17 ? '熱門政策' : '你可能喜欢' }}
                <span @click="changeNews">
                  <svg-icon icon-class="change"></svg-icon>
                  <span>换一批</span>
                </span>
              </h3>
              <div class="policy-list" v-if="typeId == 17" v-for="item in newsSwiperRes" :key="item.newsId + ''">
                <policy-item :policy="item" />
              </div>
              <div v-else class="news-list-container">
                <div v-for="item in newsSwiperRes" :key="item.newsId + ''">
                  <NewsItem :item="item" direction="col" imgSize="middle2"></NewsItem>
                  <div class="line"></div>
                </div>
              </div>
              <!-- <news-list img-direction="flex-col" :ispagination="false" v-else /> -->
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { mapState } from "vuex";
import swiperPolicy from "../common/swiper-policy.vue";
import newsList from "../common/news-list.vue";
import { getNewsList } from "@/assets/api/news.js";
import policyItem from "../common/policy-item.vue";
import NewsItem from "../common/news-item.vue";
export default {
  components: {
    swiper,
    swiperSlide,
    swiperPolicy,
    newsList,
    policyItem,
    NewsItem,
  },
  data() {
    return {
      typeId: "",
      newsSwiperRes: [],
      newsSwiperAllRes: [],
      typeArr: [
        {
          typeId: 13,
          title: "新聞頭條",
        },
        {
          typeId: 16,
          title: "經貿動態",
        },
        {
          typeId: 18,
          title: "生活資訊",
        },
        {
          typeId: 17,
          title: "政策指引",
        },
      ],
      swiperOption1: {
        slidesPerView: 1, //一页显示几个
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        speed: 1500,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        pagination: {
          el: ".swiper-pagination1",
          clickable: true,
        },
        autoplay: {
          delay: 6000, //自动切换的时间间隔
          disableOnInteraction: false,
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
        navigation: {
          nextEl: ".swiper-button-next1", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev1", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled1", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden", //按钮隐藏时的Class
        },
      },
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    console.log(this.$route);
    this.typeId = this.$route.query.typeId;
    getNewsList({
      orderByColumn: "tips",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 60,
      typeId: this.typeId == 17 ? '17' : '',
    }).then((res) => {
      // console.log(res.data);
      //你可能喜欢，随机取6条
      this.newsSwiperAllRes = res.data.rows;
      this.changeNews();
    });
  },
  methods: {
    // toDetails(item, url) {
    //   if (url) {
    //     window.open(url, "_blank");
    //   } else {
    //     if (item.price > 0) {
    //       this.$router.push({
    //         path: `/expert-details/${item.newsId}`,
    //       });
    //     } else {
    //       this.$router.push({
    //         path: `/article-details/${item.newsId}`,
    //       });
    //     }
    //   }
    // },
    changeNews() {

      this.newsSwiperRes = this.newsSwiperAllRes.sort(() => Math.random() - 0.5).slice(0, this.typeId == 17 ? 12 : 4).map((item) => {
        item.newsImage = item.newsImage ? (!/^http/.test(item.newsImage) ? this.$imgUrl + item.newsImage : item.newsImage) : '';
        item.tag = item.tag.split('|').join(' · ');
        return item;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.article {
  .title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #2C2C2E;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    margin: 40px 0 30px;
  }
}

.news-list-container {
  .line {
    width: 100%;
    height: 1px;
    background-color: #E5E5EA;
    margin: 20px 0;
  }
}

.like-news {

  h3 {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #2C2C2E;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 40px 0 30px;

    span {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #AEAEB2;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      cursor: pointer;
    }

    &:hover {
      span {
        color: #E13133;
      }
    }

  }
}

.article .banner-swiper {
  margin-top: 25px;
}

.policy-list {
  padding: 20px 0 0;
  border-bottom: 1px solid #E5E5EA;
}

.policy-list:first-child {
  padding-top: 0;
}

.swiper-box {
  width: 100%;
  position: relative;

  .news-item {
    position: relative;
    width: 100%;
    height: 100%;

    img {
      width: 825px;
      min-width: 825px;
      height: 518px;
      object-fit: cover;
    }

    .news-info {
      padding: 0 22px;
      box-sizing: border-box;

      h3 {
        font-family: NotoSansCJKTC;
        font-weight: 500;
        letter-spacing: 2px;
        margin-bottom: 4px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      p {
        font-family: NotoSansCJKTC;
        line-height: 1.71;
        letter-spacing: 1.4px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      .more {
        width: fit-content;
        padding: 7px 23px;
        border-radius: 21.5px;
        margin-top: 18px;
        font-family: NotoSansCJKTC;
        line-height: 29px;

        .svg-icon {
          width: 8px;
          height: 13px;
          margin-left: 23px;
        }
      }
    }
  }
}

.other-news {
  padding: 40px 0 80px;
}

.swiper-button-prev1 {
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 99;
  width: 35px;
  height: 45px;
  line-height: 45px;
  border-top-left-radius: 23px;
  border-bottom-left-radius: 23px;
  background: rgba(0, 0, 0, .08);
  transform: translateY(-50%) rotate(180deg);

  .svg-icon {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
  }
}

.swiper-button-next1 {
  left: 790px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
  width: 35px;
  height: 45px;
  line-height: 45px;
  border-top-left-radius: 23px;
  border-bottom-left-radius: 23px;
  background: rgba(0, 0, 0, .08);

  .svg-icon {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
  }
}

.my-button-disabled1 {
  background: rgba(0, 0, 0, .01);

  .svg-icon {
    color: rgba(255, 255, 255, .4);
  }
}

@media screen and (max-width: 768px) {
  .article {
    padding: 0 20px;
    .title {
      font-size: 24px;
      line-height: 31px;
      margin: 30px 0 20px;
    }

    .banner-swiper {
      margin-top: 0;
    }

    .main {
      background: #edeff1;
    }
  }

  .swiper-box {
    width: 100%;
    position: relative;
    padding: 10px;
    border-bottom: 20px solid #edeff1;

    .news-item {
      position: relative;
      width: 100%;
      flex-direction: column;

      img {
        width: 100%;
        min-width: 100%;
        height: 206px;
        object-fit: cover;
      }

      .news-info {
        padding: 10px 0;
        box-sizing: border-box;

        h3 {
          font-family: NotoSansCJKTC;
          font-size: 24px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: 1.2px;
          text-align: left;
          color: #222;
          margin-bottom: 10px;
        }

        p {
          display: none;
        }

        .more {
          width: fit-content;
          padding: 3px 13px 4px 19px;
          margin-top: 0;
          border-radius: 12px;
          background-color: #e13133;
          font-family: NotoSansCJKTC;
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 17px;
          letter-spacing: normal;
          text-align: left;
          color: #fff;

          .svg-icon {
            width: 8px;
            height: 13px;
            margin-left: 23px;
          }
        }
      }
    }
  }

  .other-news {
    padding: 0 0 30px;
  }
}
</style>
<style>
.article .swiper-box .swiper-pagination1 {
  position: absolute;
  bottom: 27px;
  z-index: 9;
  left: 0;
  width: 825px;
  display: flex;
  justify-content: center;
}

.article .swiper-box .swiper-pagination-bullet {
  width: 73px;
  height: 2px;
  margin: 0.1px 7px 0;
  opacity: 0.35;
  background-color: #fff;
  border-radius: 0;
}

.article .swiper-box .swiper-pagination-bullet-active {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/article/index.vue